import bookCopy from "./book-copy.svg";
import calendar from "./calendar.svg";
import calendar2 from "./calendar.svg";
import circleCheckBig from "./circle-check-big.svg";
import eye from "./eye.svg";
import files from "./files.svg";
import film from "./film.svg";
import hardDriveDownload from "./hard-drive-download.svg";
import heart from "./heart.svg";
import libraryBig from "./library-big.svg";
import messageCircleMore from "./message-circle-more.svg";
import percent from "./percent.svg";
import shapes from "./shapes.svg";
import star from "./star.svg";
import tvMinimalPlay from "./tv-minimal-play.svg";
import user from "./user.svg";

export const LUCIDE_ICONS = {
  bookCopy: bookCopy,
  calendar: calendar,
  calendar2: calendar2,
  circleCheckBig: circleCheckBig,
  eye: eye,
  files: files,
  film: film,
  hardDriveDownload: hardDriveDownload,
  heart: heart,
  libraryBig: libraryBig,
  messageCircleMore: messageCircleMore,
  percent: percent,
  shapes: shapes,
  star: star,
  tvMinimalPlay: tvMinimalPlay,
  user: user,
};
